app.service('activeElement', function (console) {
	let element = null;
	let internalElement = null;

	function set(el, internal = false) {
		if (el) {
			if (internal) {
				internalElement = el;
			} else {
				element = el;
			}

		} else if (document.activeElement !== null &&
			document.activeElement !== document.body &&
			document.activeElement !== document.documentElement) {
			if (internal) {
				internalElement = document.activeElement;
			} else {
				element = document.activeElement;
			}
		} else {
			if (internal) {
				internalElement = null;
			} else {
				element = null;
			}
		}
		if (internal) {
			console.log('Zapisanie aktywnego elementu w ramach modala', internalElement);
		} else {
			console.log('Zapisanie aktywnego elementu', element);
		}
	}
	function get(internal = false) {
		return internal ? internalElement : element;
	}
	function reset(internal = false){
		console.log('Resetowanie aktywnego elementu');
		if (internal) {
			internalElement = null;
		} else {
			element = null;
		}
	}
	function focus(internal = false){
		let localElement = get(internal);
		if (localElement) {
			reset(internal);
			setTimeout(function () {
				if(localElement){
					localElement.focus();
					console.log('Po zamknięciu modala focusowany element', localElement);
				} else {
					console.log('Brak elementu do focusowania po zamknięciu/timeoucie');
				}
			}, 100);
		} else {
			console.log('Brak elementu do focusowania po zamknięciu warstwy');
		}
	}

	return {
		set,
		get,
		reset,
		focus
	};
});
